import evessioAPI from "@/services/api/evessioAPI";
import { evessioHttpService } from "@/services/api/digitalEventHTTPs";

export default {
  /**
   * Create or update post
   * @param rootGetters
   * @param rootState
   * @param imageData
   * @param postData
   * @returns {Promise<void>}
   */
  async createGalleryPost({ rootGetters, rootState }, { imageData, postData }) {
    if (imageData.data) {
      imageData.data.set("resize_image_profile", "photo_wall_card");
      let response = await evessioHttpService.post("forms/file_response", imageData.data, imageData.config);

      if (response.data.success === "true") {
        postData.images = [];
        response.data.images.forEach(image => {
          postData.images.push({
            imageUrl: image.file_value,
            imageUuid: image.newUuid,
            mediaSizeName: image.media_size_name
          });
        });
      }
    }

    if (postData.uuid) {
      await evessioAPI.updateGalleryPost({
        card_uuid: postData.uuid,
        postData: postData,
        room_uuid: rootGetters["room/activeRoom"].uuid,
        event_uuid: rootState.event.config.uuid
      });
    } else {
      await evessioAPI.createGalleryPost({
        postData: postData,
        room_uuid: rootGetters["room/activeRoom"].uuid,
        event_uuid: rootState.event.config.uuid
      });
    }
  },
  /**
   * Get posts
   * @param commit
   * @param rootGetters
   * @param rootState
   * @param limit
   * @returns {Promise<void>}
   */
  async getGalleryPosts({ commit, rootGetters, rootState }, limit) {
    let response = await evessioAPI.getGalleryPosts({
      room_uuid: rootGetters["room/activeRoom"].uuid,
      event_uuid: rootState.event.config.uuid,
      limit: limit
    });
    commit("setGalleryPosts", response.data.data);
  },
  /**
   * Get personal posts
   * @param commit
   * @param rootGetters
   * @param rootState
   * @param limit
   * @returns {Promise<void>}
   */
  async getMyGalleryPosts({ commit, rootGetters, rootState }, limit) {
    let response = await evessioAPI.getMyGalleryPosts({
      room_uuid: rootGetters["room/activeRoom"].uuid,
      event_uuid: rootState.event.config.uuid,
      limit: limit
    });
    commit("setGalleryPosts", response.data.data);
  },
  /**
   * Delete post
   * @param rootGetters
   * @param rootState
   * @param post
   * @returns {Promise<void>}
   */
  async deleteGalleryPost({ rootGetters, rootState }, post) {
    let promises = post.images.map(i => evessioHttpService.delete(`forms/file_response/${i.imageUuid}`));

    return Promise.all(promises).then(async () => {
      await evessioAPI.deleteGalleryPost({
        card_uuid: post.uuid,
        room_uuid: rootGetters["room/activeRoom"].uuid,
        event_uuid: rootState.event.config.uuid
      });
    });
  }
};
